'use client';

import { TConfiguration } from '@nettbureau/featured-core';
import { createContext } from 'react';

type CardActionStyle = 'Floating' | 'Fixed';
type TextAlignment = 'Left' | 'Right' | 'Center';
type GlobalThemeVariant =
  | 'default'
  | 'secondary'
  | 'districtPicker'
  | 'vendorListPage'
  | 'cityListPage';

type IConfigProvider = Omit<TConfiguration, 'id'> & {
  globalThemeVariant: GlobalThemeVariant;
};

const ConfigContext = createContext<IConfigProvider>({
  cardStyle: 'Floating',
  cardTextAlignment: 'Center',
  globalThemeVariant: 'default',
  cardVisibleRows: '1',
  showBasicProfileActionButtons: false,
  moreInfoButtonOnProductCards: false,
  includeOffices: false,
  theme: 'Blue 900',
});

const ConfigProvider = ConfigContext.Provider;

export type { CardActionStyle, GlobalThemeVariant, TextAlignment };
export { ConfigContext, ConfigProvider };
